<template>
  <v-row data-test-id="eventDetails">
    <v-col cols="12">
      <DisplayText
        v-if="showCategory"
        :label="t('fields.events.category')"
        :value="eventsStore.getCategoryTitle(item.category)"
      />
      <DisplayText
        :label="t('fields.events.dtStart')"
        :value="new Date(item.dtStart).toLocaleString()"
      />
      <DisplayText :label="t('labels.events.duration')" :value="duration" />
      <DisplayText :label="t('labels.events.organizer')" :value="administratorName" />
      <DisplayText :label="t('labels.location')" :value="item.location" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { TimeValue } from '@/classes/TimeValue'
import { TableStoreId } from '@/enums/TableStoreId'
import type { IEventsStore } from '@/interfaces/api/IEventsStore'
import type { EventRecord } from '@/models/EventRecord'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { computed, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const eventsStore = TableStoreFactory.get(TableStoreId.Events) as IEventsStore
const { t } = useI18n({ useScope: 'global' })

// PROPS & EMITS
const props = defineProps({
  item: { type: Object as PropType<EventRecord>, required: true },
  showCategory: { type: Boolean, default: false }
})

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const administratorName = computed(() => {
  return `${props.item.organizerLastName}, ${props.item.organizerFirstName}`
})

const duration = computed(() => {
  const startTimeMs = new Date(props.item.dtStart).getTime()
  const endTimeMs = new Date(props.item.dtEnd).getTime()
  const durationMs = endTimeMs - startTimeMs
  const duration = TimeValue.fromMilliseconds(durationMs)
  return duration.toDurationString(
    t('labels.hours').toLowerCase(),
    t('labels.minutes').toLowerCase()
  )
})

// WATCHERS

// LIFECYCLE HOOKS

// FUNCTIONS
</script>
